import React, { useEffect, useRef } from 'react';
import { FormSection, Text, TextArea } from '../ui';
import { useOrderToEmailQuery } from '../../graphql';

export function OrderEmailInfo({
  externalOrderId,
}: {
  externalOrderId: string;
}) {
  const { data } = useOrderToEmailQuery({
    variables: {
      input: externalOrderId,
    },
  });

  const logEntry = data?.allEmailToOrderLogs?.nodes?.[0];

  const clickCounter = useRef(0);
  useEffect(() => {
    const timerId = setInterval(() => {
      if (clickCounter.current > 0) {
        clickCounter.current -= 1;
      }
    }, 1000);
    return () => clearInterval(timerId);
  }, []);
  const [parsedVisible, setParsedVisible] = React.useState(false);
  const onSourceClick = () => {
    clickCounter.current += 1;
    if (clickCounter.current > 5) {
      setParsedVisible(true);
    }
  };

  if (!logEntry) {
    return null;
  }

  const { error, parsed: serviceRawResponse } = logEntry;

  let serviceResponse: unknown;
  try {
    if (serviceRawResponse) {
      serviceResponse = JSON.parse(serviceRawResponse);
    }
  } catch (_e) {
    // Nothing
  }

  return (
    <FormSection
      title={<span onClick={onSourceClick}>Email source</span>}
      display="block"
      muted
    >
      {error && (
        <Text display="block" mb={15} color="status.error">
          <span style={{ whiteSpace: 'pre' }}>{error}</span>
        </Text>
      )}
      {parsedVisible && (serviceResponse || serviceRawResponse) ? (
        <Text display="block" mb={20}>
          <span style={{ whiteSpace: 'pre' }}>
            {serviceResponse
              ? JSON.stringify(serviceResponse, null, 4)
              : serviceRawResponse}
          </span>
        </Text>
      ) : null}

      <TextArea
        readOnly={true}
        disabled={true}
        value={'Subject: ' + logEntry.mailSubject + '\n\n' + logEntry.mailText}
        rows={20}
      ></TextArea>
    </FormSection>
  );
}
